function ActivityText({ label, text, ...rest }) {
  return (
    <>
      <span {...rest}>{label}</span> {text}
    </>
  );
}

export default ActivityText;
